
<template>
    <!-- 报价界面，只要报价处可以编辑，其他位置不行 -->
    <div>
      <el-form label-width="100px">
        <el-collapse v-model="activeNames">
            <!-- 时间 -->
            <el-collapse-item name="1">
                <template slot="title">
                <h2 style="color:red">时间</h2>
                </template>

                
                <el-row>
                <el-col :span="6">
                    <el-form-item label="询价时间:">
                        <el-date-picker
                            v-model="dataForm.bidStartTime"
                            class="text-disabled"
                            value-format="yyyy-MM-dd hh:mm:ss"
                            placeholder="请选择询价时间"
                            :disabled="true"
                            style="width:100%"
                            type="datetime">
                        </el-date-picker>
                    </el-form-item>
                </el-col>

                <el-col :span="6">
                    <el-form-item label="逾期时间:">
                        <el-date-picker
                        v-model="dataForm.bidEndTime"
                        class="text-disabled"
                        placeholder="请选择逾期时间"
                        value-format="yyyy-MM-dd hh:mm:ss"
                        :disabled="true"
                        style="width:100%"
                        type="datetime">
                        </el-date-picker>
                    </el-form-item>  
                </el-col>
                <el-col :span="6">
                    <div></div>
                </el-col>

                <el-col :offset="6" :span="6">
                    <el-button type="primary" @click="showShareQrCode" icon="el-icon-share" >分享</el-button>
                </el-col> 

                </el-row>

            </el-collapse-item>

            <!-- 基础信息 -->
            <el-collapse-item name="2">
            <template slot="title">
                <h2 style="color:red">基础信息</h2>
            </template>

            <el-row>
                <el-col :span="6">
                <el-form-item label="车辆编号">
                    <el-input class="text-disabled" :disabled="true" v-model="dataForm.vehicleSn">
                    </el-input>
                </el-form-item>
                </el-col>
                
                <el-col :span="6">
                <el-form-item label="报案号">
                    <el-input :disabled="true" class="text-disabled" v-model="dataForm.caseSn">
                    </el-input>
                </el-form-item>
                </el-col>
            </el-row>
            <!-- 保险公司 -->
            <el-row>
                <el-col :span="6">
                <el-form-item label="保险公司">
                    <el-input class="text-disabled" :disabled="true" v-model="dataForm.insurance.insureCompany">
                    </el-input>
                </el-form-item>
                </el-col>

                <el-col :span="6">
                <el-form-item label="分公司">
                    <el-input :disabled="true" class="text-disabled" v-model="dataForm.insurance.insureFiliale">
                    </el-input>
                </el-form-item>
                </el-col>

                <el-col :span="6">
                <el-form-item label="分支机构">
                    <el-input class="text-disabled" :disabled="true" v-model="dataForm.insurance.insureBranch">
                    </el-input>
                </el-form-item>
                </el-col>

            </el-row>

            <!--  第三行-->
            <el-row>
                
                <el-col :span="6">
                    <el-form-item label="登记日期">
                        
                        <el-date-picker
                        class="text-disabled"
                        :disabled="true"
                        v-model="dataForm.factory.registerDate"
                        placeholder="请选择登记日期"
                        value-format="yyyy-MM-dd"
                        type="date">
                        </el-date-picker>
                    </el-form-item>
                </el-col>

                <el-col :span="6">
                    <el-form-item label="车架号">
                        <el-input class="text-disabled" :disabled="true" v-model="dataForm.factory.vin" placeholder="请输入车架号">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="车牌号">
                        <el-input :disabled="true" class="text-disabled" v-model="dataForm.current.plateNo" placeholder="请输入车牌号">
                        </el-input>
                    </el-form-item>
                </el-col>

                
                
                <el-col :span="6">
                    <el-form-item label="发动机号">
                        <el-input class="text-disabled" :disabled="true" v-model="dataForm.factory.engineNo" placeholder="请输入发动机号"> 
                        </el-input>
                    </el-form-item>   
                </el-col>
            
            </el-row>
                <!-- 第三行 -->
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="车辆型号(品牌型号)">
                            <el-input :disabled="true" class="text-disabled" v-model="dataForm.factory.vehicleModel" placeholder="请输入车辆车型标志">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="车型">
                            <el-input class="text-disabled" :disabled="true" v-model="dataForm.factory.vehicleTradeName" placeholder="请输入车辆车型传播名">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="发票金额" >
                            <el-input :disabled="true" class="text-disabled"  v-model="dataForm.factory.invoiceValue">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    
                </el-row>

                <!--第4行  -->
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="车辆性质">
                            <el-input class="text-disabled" :disabled="true" v-model="dataForm.current.useCharacter" >
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="车辆停放地">
                            <el-input class="text-disabled" :disabled="true" v-model="dataForm.vehicleParkingArea" placeholder="请输入车辆当前停放地" clearable>
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="所有人性质(车辆归属)">
                            <el-input :disabled="true" class="text-disabled" v-model="dataForm.current.ownership" placeholder="请输入车辆的所属性质(公司/个人)">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    
                </el-row>

                <!--  -->
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="是否二手车">
                            <el-select v-model="dataForm.current.blnTransfer" class="text-disabled" placeholder="是否二手车" clearable>
                                <el-option 
                                    :disabled="true"
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>

                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="车辆类型">
                            <el-input  class="text-disabled" :disabled="true">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="发证日期">
                            
                            <el-date-picker
                                :disabled="true"
                                class="text-disabled"
                                v-model="dataForm.current.issueDate"
                                value-format="yyyy-MM-dd"
                                placeholder="请选择询价时间"
                                type="date">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="公里数">
                            <el-input :disabled="true" class="text-disabled" v-model="dataForm.current.vehicleKim">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="变速箱类型">
                            <el-input :disabled="true" class="text-disabled" v-model="dataForm.factory.gearboxType">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="排量">
                            <el-input :disabled="true" class="text-disabled" v-model="dataForm.factory.vehicleDisplacement">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <!-- <el-col :span="6">
                        <el-form-item label="乘用商用">
                            <el-input v-model="dataForm.current.passengerCommercial">
                            </el-input>
                        </el-form-item>
                    </el-col> -->
                </el-row> 

                <el-row>
                    <el-col :span="6">
                        <el-form-item label="保险金额">
                            <el-input :disabled="true" class="text-disabled" v-model="dataForm.insureAmount">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="估损金额">
                            <el-input :disabled="true" class="text-disabled" v-model="dataForm.damageCost">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="车损原因">
                            <el-input class="text-disabled" :disabled="true">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="车辆种类(事故类型)">
                            <el-input :disabled="true" class="text-disabled">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="出险日期">
                            <el-input :disabled="true" class="text-disabled">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="报价有效期">
                            <el-input :disabled="true" class="text-disabled">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="大票金额">
                            <el-input :disabled="true" class="text-disabled">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="6">
                        <el-form-item label="实际价值(全损金额)">
                            <el-input :disabled="true" class="text-disabled" v-model="dataForm.current.practicalValue">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <!--
                    <el-col :span="6">
                        <el-form-item label="定损员姓名">
                            <el-input :disabled="true" v-model="dataForm.insurance.surveyorName">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="定损员电话">
                            <el-input :disabled="true" v-model="dataForm.insurance.surveyorPhone">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    -->
                </el-row>
                
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="发动机是否完好">
                          

                            <el-select 
                                :disabled="true"
                                class="text-disabled" 
                                v-model="dataForm.damage.engineGood" placeholder="发动机是否完好" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                        
                    </el-col>
                </el-row>

                <!-- 事故备注 -->
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="事故备注">
                            <el-input :disabled="true" class="text-disabled" type="textarea" v-model="dataForm.vehicleAccidentRemark" placeholder="请输入出险地点" clearable>
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <p v-html="translateHtml(dataForm.vehicleAccidentRemark)"></p>
                    </el-col>

                    <el-col :span="6">
                        <el-tag  effect="dark" type="danger" v-if="dataForm.offeringSecond=='Y'">二次询价车辆</el-tag>
                    </el-col>
                </el-row>
            </el-collapse-item>

          
            <!-- 二次报价原因 -->
            <el-collapse-item name="3">
                <template slot="title">
                    <h2 style="color:red">二次报价原因</h2>
                </template>
                <el-row>
                    <el-input :disabled="true" v-model="dataForm.offeringReason"  class="text-disabled" type="textarea">
                    </el-input>
                </el-row>
            </el-collapse-item>


            <el-collapse-item title="二次报价附件" name="4">
                <template slot="title">
                    <h2 style="color:red">二次报价附件</h2>
                </template>
                <el-row>
                    <el-input :disabled="true" type="textarea">
                    </el-input>
                </el-row>
            </el-collapse-item>

            <!--出险信息  -->
            <el-collapse-item  name="5">
               
                <template slot="title">
                    <h2 style="color:red">出险信息</h2>
                </template>
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="责任认定">
                            <el-input 
                                :disabled="true"
                                class="text-disabled"
                                v-model="dataForm.damage.responsibility"  placeholder="请输入责任认定" >
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="车身电脑是否完整">
                            <el-select 
                                :disabled="true"
                                class="text-disabled" 
                                v-model="dataForm.damage.vehicleEcu" placeholder="请选择车身电脑是否完好" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>

                        
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="发动机电脑是否完好">
                            <el-select 
                                :disabled="true"
                                v-model="dataForm.damage.vehicleEcu" class="text-disabled" placeholder="请选择发动机电脑是否完好" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="发动机是否完好">
                            <el-select :disabled="true" v-model="dataForm.damage.engineGood" class="text-disabled" placeholder="请选择发动机是否完好" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                        
                    </el-col>

                    <el-col :span="6">    
                        <el-form-item label="是否脱审">
                            <el-select :disabled="true" v-model="dataForm.damage.delisting" class="text-disabled" placeholder="请选择是否脱审" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                        
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="人伤情况">
        
                            <el-input :disabled="true" v-model="dataForm.damage.casualties" class="text-disabled" placeholder="请输入人伤情况" >
                            </el-input>

                        </el-form-item>
                        
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="天窗是否完好">
                            <el-select :disabled="true" v-model="dataForm.damage.skylightGood" class="text-disabled" placeholder="请选择天窗是否完好" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                        
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否拆解">
                            <el-select :disabled="true" v-model="dataForm.damage.assemble" class="text-disabled" placeholder="请选择是否拆解" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    

                    

                    <el-col :span="6">
                        <el-form-item label="变速箱完好">
                            
                            <el-select :disabled="true" v-model="dataForm.damage.gearboxGood" class="text-disabled" placeholder="请选择变速箱完好" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>

                    </el-col>

                   

                    <el-col :span="6">
                        <el-form-item label="是否二次事故">
                            <el-select :disabled="true" v-model="dataForm.current.secondaryAccident" class="text-disabled" placeholder="请选择是否二次事故" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    
                    <el-col :span="6">
                        <el-form-item label="车辆大架号完好">
  
                            <el-select :disabled="true" v-model="dataForm.damage.steelSealNumber" class="text-disabled" placeholder="车辆大架号完好" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                

              
                </el-row>
            </el-collapse-item>

            <!-- 费用信息 -->
            <el-collapse-item  name="6">
                <template slot="title">
                    <h2 style="color:red">费用信息(由竞价单位承担)</h2>
                </template>
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="停车费">
                            <el-input :disabled="true" class="text-disabled" v-model="dataForm.cost.parkingFee">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="拆检费">
                            <el-input :disabled="true" class="text-disabled" v-model="dataForm.cost.overhaulFee">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="拖车费">
                            <el-input :disabled="true" class="text-disabled" v-model="dataForm.cost.towingFee">

                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="施救费">
                            <el-input :disabled="true" class="text-disabled" v-model="dataForm.cost.salvageFee">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="其他费用">
                            <el-input :disabled="true" class="text-disabled" v-model="dataForm.cost.otherFee">
                            </el-input> 
                        </el-form-item>
                    </el-col>
                </el-row>

                
                
            </el-collapse-item>

            <!-- 手续信息 -->
            <el-collapse-item  name="7">
                <template slot="title">
                    <h2 style="color:red">手续信息</h2>
                </template>
                <el-row>
                    <el-col :span="6" >
                        <el-form-item label="是否抵押">
                            <el-select :disabled="true" class="text-disabled" v-model="dataForm.procedure.mortgage" placeholder="是否抵押" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                            
                        </el-form-item>
                    </el-col>

                    <el-col :span="6" >
                        <el-form-item label="购置税本">
                            <el-select :disabled="true" class="text-disabled" v-model="dataForm.procedure.purchaseTax" placeholder="是否有购置税本" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6" >
                        <el-form-item label="是否有贷款">
                            <el-select :disabled="true" class="text-disabled" v-model="dataForm.procedure.loan" placeholder="是否有贷款" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                        
                    </el-col>

                  
                </el-row>

                <el-row>
                    <el-col :span="6">
                        <el-form-item label="组织机构代码证">
                            <el-select  :disabled="true" class="text-disabled" v-model="dataForm.procedure.organizationCodeCertificate" placeholder="是否有组织机构代码证" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="权益转让书">
                             <el-select :disabled="true" class="text-disabled" v-model="dataForm.procedure.subrogationReceipt" placeholder="是否有组织机构代码证" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="委托协议">
                             <!-- <el-select  clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select> -->
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="破案证书">
                             <!-- <el-select  placeholder="是否有组织机构代码证" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select> -->
                        </el-form-item>
                    </el-col>
                </el-row>
        
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="车主身份证复印件">
                             <el-select :disabled="true" class="text-disabled" v-model="dataForm.procedure.idCardCopy" placeholder="是否有组织机构代码证" clearable>
                                <el-option 
                                    :disabled="true"
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="钥匙">
                             <el-select :disabled="true" class="text-disabled" v-model="dataForm.procedure.vehicleKey" placeholder="是否有组织机构代码证" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>


                    <el-col :span="6">
                        <el-form-item label="车牌">
                            
                             <el-select :disabled="true" class="text-disabled" v-model="dataForm.procedure.licencePlate" placeholder="是否有车牌" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="行驶证">
                            <el-select :disabled="true" class="text-disabled" v-model="dataForm.procedure.vehicleLicense" placeholder="是否有车牌" clearable>
                                <el-option 
                                    :disabled="true"
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="登记证书">
                            <el-select :disabled="true" class="text-disabled" v-model="dataForm.procedure.registrationCertificate" placeholder="是否有车牌" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            
            </el-collapse-item>

            <!-- 照片 -->
            <el-collapse-item  name="8">
                <template slot="title">
                    <h2 style="color:red">照片</h2>
                </template>
             
                <el-image 
                    style="width: 100px; height: 100px"
                    v-for="urlItem in dataForm.damage.imgUrls" :key="urlItem" :src="urlItem"
                    :preview-src-list="dataForm.damage.imgUrls">
                </el-image> 
                
             

            </el-collapse-item>
            <!-- 车300 评估 -->
            <el-collapse-item name="9">
                <template slot="title">
                    <h2 style="color:red">车300评估结果</h2>
                </template>

                <el-tabs  type="card" @tab-click="handleEvaluateTabClick" >
                    <el-tab-pane v-for="tab in dataForm.evaluate" :key="tab.modelId	" :label="tab.modelName" :name="tab.modelName">
                        <!-- <component :is="tab.component" v-bind="tab.props"></component> -->
                        <el-descriptions border>
                            <el-descriptions-item label="车型">
                                {{tab.modelName}}
                            </el-descriptions-item>
                            <el-descriptions-item label="品牌名">
                                {{tab.brandName	}}
                            </el-descriptions-item>
                            <el-descriptions-item label="系列名">
                                {{tab.seriesName}}
                            </el-descriptions-item>

                            <el-descriptions-item label="户籍地">
                                {{tab.cityName}}
                            </el-descriptions-item>

                            <el-descriptions-item label="预估里程">
                                {{tab.mileAge}}
                            </el-descriptions-item>

                            <el-descriptions-item label="新车指导价">
                                {{tab.modelPrice}}
                            </el-descriptions-item>

                        
                            <el-descriptions-item label="出厂日期">
                                {{tab.regDate}}
                            </el-descriptions-item>
                            <el-descriptions-item label="特别提醒">
                                第三方提供数据,请以实车为准
                            </el-descriptions-item>
                        </el-descriptions>

                        <el-radio-group v-model="radioCondition" @change="handleChangeCondition($event,tab)">
                            <el-radio-button label="normal">车况一般</el-radio-button>
                            <el-radio-button label="good">车况良好</el-radio-button>
                            <el-radio-button label="excelent">车况优秀</el-radio-button>
                        </el-radio-group>

                        <el-row :gutter="20">
                            <el-col :span="6">
                                <el-statistic
                                    :value="evaluatePrice.dealerLowBuyPrice"
                                    title="车商最低收车价(万元)"
                                ></el-statistic>
                            </el-col>
                            <el-col :span="6">
                                <el-statistic
                                    :value="evaluatePrice.dealerBuyPrice"
                                    title="车商收车价(万元)"
                                ></el-statistic>
                            </el-col>
                            <el-col :span="6">
                                <el-statistic
                                :value="evaluatePrice.individualLowSoldPrice"
                                title="个人最低交易价(万元)"
                                ></el-statistic>
                            </el-col>

                            <el-col :span="6">
                                <el-statistic
                                    :value="evaluatePrice.individualPrice"
                                    title="个人交易价(万元)"
                                ></el-statistic>
                            </el-col>

                            <el-col :span="6">
                                <el-statistic
                                    :value="evaluatePrice.dealerLowSoldPrice"
                                    title="车商最低零售价(万元)"
                                ></el-statistic>
                            </el-col>
                            
                            <el-col :span="6">
                                <el-statistic
                                    :value="evaluatePrice.dealerPrice"
                                    title="车商零售价(万元)"
                                ></el-statistic>
                            </el-col>
                            <el-col :span="6">
                                <el-statistic
                                    :value="evaluatePrice.dealerHighSoldPrice"
                                    title="车商最高零售价(万元)"
                                ></el-statistic>
                            </el-col>
                        
                        </el-row>
                    </el-tab-pane>
                
                </el-tabs>
            </el-collapse-item>
            <!-- 定级 -->
            <el-collapse-item name="10">
                <template slot="title">
                    <h2 style="color:red">定级/审核</h2>
                </template>
                <el-row >
                    <el-col :span="6">
                        <el-form-item label="车辆级别">

                            <el-select v-model="dataForm.check.vehicleLevelGrade" :disabled="true" class="text-disabled" >
                                <el-option
                                v-for="dict in dict.type.vehicle_level_grade"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                >

                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="事故类型">
                            
                            <el-select v-model="dataForm.check.vehicleLevel" :disabled="true" class="text-disabled" >
                                <el-option
                                v-for="dict in dict.type.vehicle_level"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                >

                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col >
                    <el-col :span="6">
                        <el-form-item label="区域">
                           
                            <el-select v-model="dataForm.check.district"  :disabled="true" class="text-disabled" >
                                <el-option
                                v-for="dict in dict.type.vehicle_district"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                >

                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      
                    </el-col>
                    
                </el-row>
                
            </el-collapse-item>

        </el-collapse> 
      </el-form>

      <el-form label-width="100px"  :model="quoteForm">
        <el-row>
            <el-col :span="6">
                <el-form-item label="新车价格">
                    <el-input v-model="quoteForm.newCarPrice" >
                    </el-input>
                </el-form-item>
            </el-col>

            <el-col :span="6">
                <el-form-item label="二手车价格">
                    <el-input v-model="quoteForm.usedCarPrice" @input="calcuatePrice">
                    </el-input>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="维修费">
                    <el-input v-model="quoteForm.maintenanceCost" @input="calcuatePrice">
                    </el-input>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="客户利润">
                    <el-input v-model="quoteForm.profit" @input="calcuatePrice">
                    </el-input>
                </el-form-item>
            </el-col>
          
        </el-row>
        <el-row>
            <el-col :span="6">
                <el-form-item label="公司利润">
                    <el-input v-model="quoteForm.profitCompany" @input="calcuatePrice">
                    </el-input>
                </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
                <el-form-item label="拖车费">
                    <el-input v-model="quoteForm.towingFee" @input="calcuatePrice">
                    </el-input>
                </el-form-item>
            </el-col> -->
            <el-col :span="6">
                <el-form-item label="其他费用">
                    <el-input v-model="quoteForm.otherFee" @input="calcuatePrice">
                    </el-input>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="理论价格">
                    <el-input :disabled="true" v-model="quoteForm.theoryPrice"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        
        <el-row>
           

            <el-col :span="6">
                <el-form-item label="最终报价">
                    <el-input v-model="quoteForm.finalPrice">
                    </el-input>
                    
                </el-form-item>
                
               
            </el-col>
            <el-col :span="8">
                <el-form-item  label="报价备注">
                    <el-input  type="textarea" v-model="quoteForm.quoteRemark">
                    </el-input>
                </el-form-item>
            </el-col>

        </el-row>

        
        <el-row>

          
            <el-col :span="6">
                <el-form-item>
                    <el-button type="primary" @click="handleShowQueryHistoryView">查看同类车型报价</el-button>
                </el-form-item>
            </el-col>

            
            <el-col :span="6">
                <el-form-item>
                    <el-button type="primary" @click="handleSubmitQuote">提交报价</el-button>
                </el-form-item>
            </el-col>
        </el-row>

      </el-form>

      <el-dialog :visible.sync="showQrDialog" width="300px">
        <qr-dialog  :qrUrl="shareQrUrl">
        </qr-dialog>
      </el-dialog>
      
      <!-- 弹出抽屉 -->
      <el-drawer
        title="历史车辆"
        size="40%"
        :visible.sync="historyDrawer">

            <history-view :vehicleName="dataForm.factory.vehicleTradeName"></history-view>
      </el-drawer>

    </div>
</template>

<script>
import {getCaseNoSurveyor,getCaseListByVehicleModel} from '@/api/vehicle/case'
import {getQuote,addQuote} from '@/api/vehicle/quote'
import QrDialog from "@/components/QrDialog/index.vue"
import HistoryView  from "@/views/components/historyview/index.vue"

export default {
  name:'Edit',
  dicts:['sys_yes_no','vehicle_district','vehicle_level','vehicle_level_grade'],
  components:{QrDialog,HistoryView},
  data(){
    return{
        historyDrawer:false,
        radioCondition:'normal',
        evaluatePrice:{},

        currentHost:'',
        routerPath:'',
        fromPath:'',//上一个页面的路由地址
        
        caseId:'',
        activeNames:['0','1','2','3','4','5','6','7','8','9','10'],
        dataForm:{
            bidStartTime:'',//询价时间(竞价开始)
            bidEndTime:'',//逾期时间(竞价结束)
                
            vehicleSn:'', //车辆编号
            caseSn:'',//报案号
            vehicleParkingArea:'',//车辆停放地

            useCharacter:'',// 车辆使用性质
            vehicleDisplacement:'',//排量
               
            accidentType:'',//事故类型
                
            insureAmount:'',//保险金额
            actualAmount:'',//实际金额

            damageCost:'',// 
            vehicleAccidentRemark:'',  
            //出厂信息
            factory:{
                vin:'',//车架号
                engineNo:'',//发动机号
                registerDate:'',//登记(注册)日期
                vehicleModel:'',//车辆型号(行车证)
                vehicleTradeName:'',//车型型号；传播名
                gearboxType:'',// 变速箱类型
                vehicleDisplacement:'',//汽车排量
                invoiceValue:'',//发票金额
            },

            //当前车辆信息
            current:{
                plateNo:'',//车牌号
                blnTransfer:'',//是否过户
                vehicleKim:'',//公里数
                issueDate:'',//发证日期
                passengerCommercial:'',//乘用商用
                practicalValue:'',//实际价值
                ownership:'',//所有人性质
            },

            //车损信息
            damage:{
                engineGood:'',//发动机是否完好
                vehicleEcu:'',//车身电脑
                engineEcu:'',//发动机电脑
                responsibility:'',//责任认定
                delisting:'',//是否脱审
                casualties:'',//人员伤害
                assemble:'',//是否拆解
                imgUrls:[],//显示的图片列表
            },

            insurance:{
                insureCompany:'',// 保险公司
                insureFiliale:'',// 保险分公司
                insureBranch:'',// 分支机构
                surveyorName:'', //定损员姓名
                surveyorPhone:'',//定损员电话
            },

            // 费用信息
            cost:{
                overhaulFee:'',//拆检费
                otherFee:'',//其他费用
                parkingFee:'',//停车费
                salvageFee:'',//施救费
                towingFee:'',//拖车费
            },
            //手续信息
            procedure:{
                mortgage:'',//是否抵押
                licencePlate:'',//车牌
                loan:'',//是否有贷款
                idCardCopy:'',//身份证复印件
                organizationCodeCertificate:'',//组织机构代码证是否有
                purchaseTax:'',//购置税本
                registrationCertificate:'',//登记证书是否有
                subrogationReceipt:'',//权益转让书
                vehicleKey:'',//车钥匙
                vehicleLicense:'',//行驶证
            },

            check:{
                vehicleLevelGrade:'',
            }
        },

        quoteForm:{
            caseId:'',
            newCarPrice:'',
            usedCarPrice:'',//二手车价格
            finalPrice:'',//最终价格
            profit:'',//客户利润
            profitCompany:'',// 公司利润
            otherFee:'',//其他费用
            towingFee:'',//拖车费
            maintenanceCost:'',//维修费
            theoryPrice:'',//理论价格
            quoteRemark:'',
        },

        historyForm:{
            modleName:'',
        },

        showQrDialog:false,
        shareQrUrl:'',
    }
  },
  mounted(){
        //字符串拼接添加点击事件
        (window.getDownLoad = (url) => {
            // location.href = url
            window.open(url)
        })
  },
  created(){
    this.currentHost="http://"+window.location.host+"/#/"
   
    const caseId=this.$route.query.caseid;
    this.shareQrUrl=this.currentHost+"sharedetail?caseid="+caseId
   
    this.routerPath=this.$route.path;
    if(caseId){
        this.caseId=caseId;
        // 通过caseId 获取详情
        this.handleGetDetail(caseId);
        this.handleGetQuote(caseId);
    }
  },
  beforeRouteEnter(to, from, next) {
  
    next(vm=>{
        //通过Caseid 判断就行
        vm.fromPath = from.fullPath;
        if(to.query.caseid!=vm.caseId){
            vm.caseId=to.query.caseid;
            // 通过caseId 获取详情
            vm.handleGetDetail(vm.caseId);
            vm.handleGetQuote(vm.caseId);
        }
        
    })
  },
  methods:{
    /***
     * 
     */
    handleEvaluateTabClick(tab, event){
        
        const index=tab.index;
        this.radioCondition="normal"
        this.evaluatePrice=this.dataForm.evaluate[index].normal;
    },

    //给字符串中的链接用span标签包裹起来，实现点击跳转
    translateHtml (msg) {
        if (msg === null || msg === undefined || msg === ''){
            return msg;
        }
        var reg =/((http|https):\/\/[-A-Za-z0-9+&@#()/%?=~_|!:,.;]+[-A-Za-z0-9+&@#()/%=~_|])/g
        var textR = msg.replace(
        reg,
        `<span style='color:#2660f5;text-decoration:underline;' onclick=getDownLoad('$1')>$1</span>`
        )
        return textR
    },

    //切换 车况
    handleChangeCondition(value,param){
        
        if (value=="good"){
            
            this.evaluatePrice=param.good;
        }

        if(value=="normal"){
            this.evaluatePrice=param.normal;
            
        }
        if(value=="excelent"){
            this.evaluatePrice=param.excellent;
            
            console.log(param.excellent);
        }

    },

    //显示素材详情
    handleGetDetail(caseId){
        // 获取详情
        getCaseNoSurveyor(caseId)
        .then(res=>{
            this.dataForm=res.data;
            this.dataForm.damage.imgUrls=JSON.parse(this.dataForm.damage.imgUrls)
         
            
            this.calculateOtherFee();
        })
        .catch(error=>{
            console.log("获取详情异常")
        })
    },

    handleGetQuote(caseId){
        getQuote(caseId)
        .then(res=>{
            
            if(res.data!=null){
                this.quoteForm=res.data;
                this.quoteForm.quoteRemark=res.data.remark
                this.calcuatePrice();
            }
            
            // res.data;
        })
        .catch(error=>{

        })
    },
    /**
     * 计算其他费用
     */
    calculateOtherFee(){
       

        this.quoteForm.otherFee=Number(this.dataForm.cost.overhaulFee)
        +Number(this.dataForm.cost.parkingFee)
        +Number(this.dataForm.cost.salvageFee)
        +Number(this.dataForm.cost.towingFee)
        +Number(this.dataForm.cost.otherFee);

       
    },
    //计算价格
    calcuatePrice(){
        
    
        this.quoteForm.theoryPrice=this.quoteForm.usedCarPrice
        -this.quoteForm.maintenanceCost
        -this.quoteForm.profit
        -this.quoteForm.profitCompany
        -this.quoteForm.otherFee
        -this.quoteForm.towingFee
    },

    //提交报价
    handleSubmitQuote(){
        this.quoteForm.caseId=this.caseId;
        addQuote(this.quoteForm)
        .then(res=>{
            if(res.success){
                this.$message.success("提交成功");
                this.handleClose();
            }else{
                this.$message.error("提交失败");
            }
        })
        .catch(error=>{
            this.$message.error(error);
        })
    },

    /**
     * 查询历史;
     */
    handleShowQueryHistoryView(){
        this.historyDrawer=true;
    },

   

    // 关闭
    handleClose(){
        // const obj = { path: "/vehicle-quote/list" };
        const obj = { path: this.fromPath};
        this.$tab.closeOpenPage(obj);
    },
    
    // 显示分享的二维码
    showShareQrCode(){
        this.showQrDialog=true;
    }
  }, 
}
</script>

<style lang="scss" scoped>

.text-disabled{
    width:100%;
    -webkit-text-fill-color: #000502 !important; //修改输入框文字颜色
    // font-size: large;
    // font-weight: bolder;
}

</style>